export const DecoyForm = () => (
	<>
		<input
			type="text"
			name="username"
			autoComplete="username"
			tabIndex={-1}
			aria-hidden="true"
			style={{ position: 'absolute', left: '-9999px', height: 0, width: 0, opacity: 0 }}
		/>
	</>
);
